/** Default Form.io form definition stored in the portal `schema` field. */
export const EMPTY_FORMIO_FORM = Object.freeze({
  display: 'form',
  components: [],
});
